import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import Vuetify, {
  VAlert,
  VSelect,
  VBtn,
  VRadioGroup,
  VRadio,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent
} from "vuetify/lib";
Vue.use(Vuetify, {
  components: {
    VAlert,
    VSelect,
    VBtn,
    VRadioGroup,
    VRadio,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent
  }
});

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#33ccff",
        secondary: "#7C8388",
        accent: "#334EFF",
        error: "#FF3333",
        info: "#8C97A1",
        success: "#17CF79"
        // warning: "#FFBB33"
      }
    }
  }
});
